// import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { FaUser, FaLock } from "react-icons/fa";

// function Adminlogin() {
//   return (
//     <div
//       style={{
//         height: "100vh",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         background: "linear-gradient(135deg, #0f2027, #203a43, #2c5364)",
//         position: "relative",
//         overflow: "hidden",
//         padding: "15px",
//       }}
//     >
//       {/* Background Blur Circle */}
//       <div
//         style={{
//           position: "absolute",
//           width: "250px",
//           height: "250px",
//           background: "rgba(11,189,157,0.2)",
//           filter: "blur(120px)",
//           borderRadius: "50%",
//           top: "10%",
//           left: "20%",
//         }}
//       ></div>

//       {/* Login Box */}
//       <div
//         style={{
//           background: "rgba(255,255,255,0.08)",
//           backdropFilter: "blur(15px)",
//           padding: "40px 20px",
//           borderRadius: "25px",
//           width: "100%",
//           maxWidth: "420px",
//           boxShadow: "0 20px 60px rgba(0,0,0,0.4)",
//           textAlign: "center",
//           border: "1px solid rgba(255,255,255,0.1)",
//         }}
//       >
//         {/* Icon */}
//         <div
//           style={{
//             width: "65px",
//             height: "65px",
//             background: "linear-gradient(135deg, #0bbd9d, #4dd0b0)",
//             borderRadius: "50%",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             margin: "0 auto 15px",
//             color: "#fff",
//             fontSize: "26px",
//             boxShadow: "0 0 20px rgba(11,189,157,0.6)",
//           }}
//         >
//           <FaUser />
//         </div>

//         {/* Title */}
//         <h3
//           style={{
//             marginBottom: "25px",
//             fontWeight: "600",
//             color: "#fff",
//             letterSpacing: "1px",
//           }}
//         >
//           Admin Login
//         </h3>

//         {/* Username */}
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             background: "rgba(255,255,255,0.1)",
//             borderRadius: "25px",
//             padding: "12px 15px",
//             marginBottom: "15px",
//             border: "1px solid rgba(255,255,255,0.1)",
//           }}
//         >
//           <FaUser style={{ color: "#0bbd9d", marginRight: "10px" }} />
//           <input
//             type="text"
//             placeholder="Username"
//             style={{
//               border: "none",
//               outline: "none",
//               background: "transparent",
//               width: "100%",
//               color: "#fff",
//               fontSize: "14px",
//             }}
//           />
//         </div>

//         {/* Password */}
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             background: "rgba(255,255,255,0.1)",
//             borderRadius: "25px",
//             padding: "12px 15px",
//             marginBottom: "15px",
//             border: "1px solid rgba(255,255,255,0.1)",
//           }}
//         >
//           <FaLock style={{ color: "#0bbd9d", marginRight: "10px" }} />
//           <input
//             type="password"
//             placeholder="Password"
//             style={{
//               border: "none",
//               outline: "none",
//               background: "transparent",
//               width: "100%",
//               color: "#fff",
//               fontSize: "14px",
//             }}
//           />
//         </div>

//         {/* Button */}
//         <button
//           style={{
//             width: "100%",
//             border: "none",
//             borderRadius: "25px",
//             padding: "12px",
//             background: "linear-gradient(to right, #0bbd9d, #4dd0b0)",
//             color: "#fff",
//             fontWeight: "600",
//             marginTop: "10px",
//             cursor: "pointer",
//             boxShadow: "0 5px 20px rgba(11,189,157,0.5)",
//             transition: "0.3s",
//           }}
//           onMouseOver={(e) => {
//             e.target.style.transform = "scale(1.03)";
//           }}
//           onMouseOut={(e) => {
//             e.target.style.transform = "scale(1)";
//           }}
//         >
//           Log In
//         </button>

//         {/* Forgot */}
//         <p
//           style={{
//             marginTop: "12px",
//             fontSize: "13px",
//             color: "#0bbd9d",
//             cursor: "pointer",
//           }}
//         >
//           Forgot password?
//         </p>
//       </div>
//     </div>
//   );
// }

// export default Adminlogin;



// import React, { useState } from "react";
// import axios from "axios";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { FaUser, FaLock } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";

// function Adminlogin() {
//   const [mobile, setMobile] = useState("");
//   const [pass, setPass] = useState("");
//   const navigate = useNavigate();

//   const handleLogin = async () => {
//     if (!mobile || !pass) {
//       alert("Please fill all fields");
//       return;
//     }

//     try {
//      const res = await axios.post(
//   "https://api.d2associates.in/daso//admin-login",
//   {
//     mobile_no: mobile.trim(),
//     password: pass.trim(),
//   }
// );

//       console.log(res.data);

   
   
// if (res.data.user?.role === "admin") {
//   alert("Admin Login Successful");
//          navigate("/admin-dashboard"); 
//       } else {
//         alert("Not Admin");
//       }

//     } catch (err) {
//       console.error(err);
//       alert(err.response?.data?.message || "Login Failed");
//     }
//   };

//   return (
//     <div
//       style={{
//         height: "100vh",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         background: "linear-gradient(135deg, #0f2027, #203a43, #2c5364)",
//         position: "relative",
//         overflow: "hidden",
//         padding: "15px",
//       }}
//     >
//       <div
//         style={{
//           position: "absolute",
//           width: "250px",
//           height: "250px",
//           background: "rgba(11,189,157,0.2)",
//           filter: "blur(120px)",
//           borderRadius: "50%",
//           top: "10%",
//           left: "20%",
//         }}
//       ></div>

//       <div
//         style={{
//           background: "rgba(255,255,255,0.08)",
//           backdropFilter: "blur(15px)",
//           padding: "40px 20px",
//           borderRadius: "25px",
//           width: "100%",
//           maxWidth: "420px",
//           boxShadow: "0 20px 60px rgba(0,0,0,0.4)",
//           textAlign: "center",
//           border: "1px solid rgba(255,255,255,0.1)",
//         }}
//       >
//         <div
//           style={{
//             width: "65px",
//             height: "65px",
//             background: "linear-gradient(135deg, #0bbd9d, #4dd0b0)",
//             borderRadius: "50%",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             margin: "0 auto 15px",
//             color: "#fff",
//             fontSize: "26px",
//           }}
//         >
//           <FaUser />
//         </div>

//         <h3 style={{ marginBottom: "25px", color: "#fff" }}>
//           Admin Login
//         </h3>

//         {/* Username */}
//         <div style={{
//           display: "flex",
//           alignItems: "center",
//           background: "rgba(255,255,255,0.1)",
//           borderRadius: "25px",
//           padding: "12px 15px",
//           marginBottom: "15px",
//         }}>
//           <FaUser style={{ color: "#0bbd9d", marginRight: "10px" }} />
//           <input
//             type="text"
//             placeholder="Mobile"
//             value={mobile}
//             onChange={(e) => setMobile(e.target.value)}
//             style={{
//               border: "none",
//               outline: "none",
//               background: "transparent",
//               width: "100%",
//               color: "#fff",
//             }}
//           />
//         </div>

//         {/* Password */}
//         <div style={{
//           display: "flex",
//           alignItems: "center",
//           background: "rgba(255,255,255,0.1)",
//           borderRadius: "25px",
//           padding: "12px 15px",
//           marginBottom: "15px",
//         }}>
//           <FaLock style={{ color: "#0bbd9d", marginRight: "10px" }} />
//           <input
//             type="password"
//             placeholder="Password"
//             value={pass}
//             onChange={(e) => setPass(e.target.value)}
//             style={{
//               border: "none",
//               outline: "none",
//               background: "transparent",
//               width: "100%",
//               color: "#fff",
//             }}
//           />
//         </div>

//         {/* Button */}
//         <button
//           onClick={handleLogin}
//           style={{
//             width: "100%",
//             border: "none",
//             borderRadius: "25px",
//             padding: "12px",
//             background: "linear-gradient(to right, #0bbd9d, #4dd0b0)",
//             color: "#fff",
//             fontWeight: "600",
//             cursor: "pointer",
//           }}
//         >
//           Log In
//         </button>

//         <p style={{ marginTop: "12px", fontSize: "13px", color: "#0bbd9d" }}>
//           Forgot password?
//         </p>
//       </div>
//     </div>
//   );
// }

// export default Adminlogin;

// import React, { useState } from "react";
// import axios from "axios";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { FaUser, FaLock } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";

// function Adminlogin() {
//   const [mobile, setMobile] = useState("");
//   const [password, setPassword] = useState("");
//   const navigate = useNavigate();

//   const handleLogin = async () => {
//     if (!mobile || !password) {
//       alert("Please fill all fields");
//       return;
//     }

//     try {
//       const res = await axios.post(
//         "https://api.d2associates.in/daso//admin-login",
//         {
//           mobile_no: mobile.trim(),
//           password: password.trim(),
//         }
//       );

//       console.log(res.data);
      
//       const data = res.data;
//       // console.log(data.user);


//       localStorage.setItem("admin", JSON.stringify(data.user));


//       if (res.data.user?.role === "admin") {
//         alert("Login successful");
//         navigate("/admin/dashboard");
//           window.location.reload();
//       } 
//     } catch (err) {
//       console.error(err);
//       alert(err.response?.data?.message || "Login Failed");
//     }
//   };

//   return (
//     <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center", background: "linear-gradient(135deg, #0f2027, #203a43, #2c5364)", position: "relative", overflow: "hidden", padding: "15px" }}>

//       <div style={{ position: "absolute", width: "250px", height: "250px", background: "rgba(11,189,157,0.2)", filter: "blur(120px)", borderRadius: "50%", top: "10%", left: "20%" }}></div>

//       <div style={{ background: "rgba(255,255,255,0.08)", backdropFilter: "blur(15px)", padding: "40px 20px", borderRadius: "25px", width: "100%", maxWidth: "420px", boxShadow: "0 20px 60px rgba(0,0,0,0.4)", textAlign: "center", border: "1px solid rgba(255,255,255,0.1)" }}>

//         <div style={{ width: "65px", height: "65px", background: "linear-gradient(135deg, #0bbd9d, #4dd0b0)", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center", margin: "0 auto 15px", color: "#fff", fontSize: "26px" }}>
//           <FaUser />
//         </div>

//         <h3 style={{ marginBottom: "25px", color: "#fff" }}>Admin Login</h3>

//         {/* Username */}
//         <div style={{ display: "flex", alignItems: "center", background: "rgba(255,255,255,0.1)", borderRadius: "25px", padding: "12px 15px", marginBottom: "15px" }}>
//           <FaUser style={{ color: "#0bbd9d", marginRight: "10px" }} />
//           <input
//             type="text"
//             placeholder="Mobile"
//             value={mobile}
//             onChange={(e) => setMobile(e.target.value)}
//             style={{ border: "none", outline: "none", background: "transparent", width: "100%", color: "#fff" }}
//           />
//         </div>

//         {/* Password */}
//         <div style={{ display: "flex", alignItems: "center", background: "rgba(255,255,255,0.1)", borderRadius: "25px", padding: "12px 15px", marginBottom: "15px" }}>
//           <FaLock style={{ color: "#0bbd9d", marginRight: "10px" }} />
//           <input
//             type="password"
//             placeholder="Password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             style={{ border: "none", outline: "none", background: "transparent", width: "100%", color: "#fff" }}
//           />
//         </div>

//         {/* Button */}
//         <button
//           onClick={handleLogin}
//           style={{ width: "100%", border: "none", borderRadius: "25px", padding: "12px", background: "linear-gradient(to right, #0bbd9d, #4dd0b0)", color: "#fff", fontWeight: "600", cursor: "pointer" }}
//         >
//           Log In
//         </button>

//         <p style={{ marginTop: "12px", fontSize: "13px", color: "#0bbd9d" }}>
//           Forgot password?
//         </p>

//       </div>
//     </div>
//   );
// }

// export default Adminlogin;

// import React, { useState } from "react";
// import axios from "axios";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { FaUser, FaLock } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";

// function Adminlogin() {
//   const [mobile, setMobile] = useState("");
//   const [password, setPassword] = useState("");
//   const navigate = useNavigate();

//   const handleLogin = async () => {
//     if (!mobile || !password) {
//       alert("Please fill all fields");
//       return;
//     }

//     try {
//       const res = await axios.post(
//         "https://api.d2associates.in/daso//admin-login",
//         {
//           mobile_no: mobile.trim(),
//           password: password.trim(),
//         }
//       );

//       const data = res.data;

//       localStorage.setItem("admin", JSON.stringify(data.user));

//       if (res.data.user?.role === "admin") {
//         alert("Login successful");
//         navigate("/admin/dashboard");
//         window.location.reload();
//       }
//     } catch (err) {
//       console.error(err);
//       alert(err.response?.data?.message || "Login Failed");
//     }
//   };

//   return (
//     <div
//       style={{
//         height: "100vh",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         background: "linear-gradient(135deg, #0f2027, #203a43, #2c5364)",
//         position: "relative",
//         overflow: "hidden",
//         padding: "15px",
//       }}
//     >
   
//       <style>
//         {`
//           input:-webkit-autofill {
//             -webkit-box-shadow: 0 0 0 1000px transparent inset !important;
//             -webkit-text-fill-color: #fff !important;
//             transition: background-color 9999s ease-in-out 0s;
//           }
//         `}
//       </style>

//       <div
//         style={{
//           position: "absolute",
//           width: "250px",
//           height: "250px",
//           background: "rgba(11,189,157,0.2)",
//           filter: "blur(120px)",
//           borderRadius: "50%",
//           top: "10%",
//           left: "20%",
//         }}
//       ></div>

//       <div
//         style={{
//           background: "rgba(255,255,255,0.08)",
//           backdropFilter: "blur(15px)",
//           padding: "40px 20px",
//           borderRadius: "25px",
//           width: "100%",
//           maxWidth: "420px",
//           boxShadow: "0 20px 60px rgba(0,0,0,0.4)",
//           textAlign: "center",
//           border: "1px solid rgba(255,255,255,0.1)",
//         }}
//       >
//         <div
//           style={{
//             width: "65px",
//             height: "65px",
//             background: "linear-gradient(135deg, #0bbd9d, #4dd0b0)",
//             borderRadius: "50%",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             margin: "0 auto 15px",
//             color: "#fff",
//             fontSize: "26px",
//           }}
//         >
//           <FaUser />
//         </div>

//         <h3 style={{ marginBottom: "25px", color: "#fff" }}>
//           Admin Login
//         </h3>


//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             background: "rgba(255,255,255,0.1)",
//             borderRadius: "25px",
//             padding: "12px 15px",
//             marginBottom: "15px",
//           }}
//         >
//           <FaUser style={{ color: "#0bbd9d", marginRight: "10px" }} />
//           <input
//             type="text"
//             placeholder="Mobile"
//             value={mobile}
//             onChange={(e) => setMobile(e.target.value)}
//             style={{
//               border: "none",
//               outline: "none",
//               background: "transparent",
//               width: "100%",
//               color: "#fff",
//               WebkitBoxShadow: "0 0 0 1000px transparent inset",
//               WebkitTextFillColor: "#fff",
//             }}
//           />
//         </div>

     
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             background: "rgba(255,255,255,0.1)",
//             borderRadius: "25px",
//             padding: "12px 15px",
//             marginBottom: "15px",
//           }}
//         >
//           <FaLock style={{ color: "#0bbd9d", marginRight: "10px" }} />
//           <input
//             type="password"
//             placeholder="Password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             style={{
//               border: "none",
//               outline: "none",
//               background: "transparent",
//               width: "100%",
//               color: "#fff",
//               WebkitBoxShadow: "0 0 0 1000px transparent inset",
//               WebkitTextFillColor: "#fff",
//             }}
//           />
//         </div>

//         {/* Button */}
//         <button
//           onClick={handleLogin}
//           style={{
//             width: "100%",
//             border: "none",
//             borderRadius: "25px",
//             padding: "12px",
//             background: "linear-gradient(to right, #0bbd9d, #4dd0b0)",
//             color: "#fff",
//             fontWeight: "600",
//             cursor: "pointer",
//           }}
//         >
//           Log In
//         </button>

//         {/* <p
//           style={{
//             marginTop: "12px",
//             fontSize: "13px",
//             color: "#0bbd9d",
//           }}
//         >
//           Forgot password?
//         </p> */}
//       </div>
//     </div>
//   );
// }

// export default Adminlogin;
// import React, { useState } from "react";
// import axios from "axios";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { FaUser, FaLock } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import logo from "../../Images/logo2.png";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// function Adminlogin() {
//   const [mobile, setMobile] = useState("");
//   const [password, setPassword] = useState("");
//   const navigate = useNavigate();

//   const handleLogin = async () => {
//     if (!mobile || !password) {
//       alert("Please fill all fields");
//       return;
//     }

//     try {
//       const res = await axios.post(
//         "https://api.d2associates.in/daso/admin-login",
//         {
//           mobile_no: mobile.trim(),
//           password: password.trim(),
//         }
//       );

//       const data = res.data;

//       localStorage.setItem("admin", JSON.stringify(data.user));

//       if (res.data.user?.role === "admin") {
//         alert("Login successful");
//         navigate("/admin/dashboard");
//         window.location.reload();
//       }
//     } catch (err) {
//       console.error(err);
//       alert(err.response?.data?.message || "Login Failed");
//     }
//   };

//   return (
//     <div
//       style={{
//         height: "100vh",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         background: "linear-gradient(135deg, #6c4636, #a67c6b)",
//         position: "relative",
//         overflow: "hidden",
//         padding: "15px",
//       }}
//     >
//       <style>
//         {`
//           input:-webkit-autofill {
//             -webkit-box-shadow: 0 0 0 1000px transparent inset !important;
//             -webkit-text-fill-color: #3e2a22 !important;
//           }
//         `}
//       </style>

//       <div
//         style={{
//           position: "absolute",
//           width: "250px",
//           height: "250px",
//           background: "rgba(212,194,187,0.3)",
//           filter: "blur(120px)",
//           borderRadius: "50%",
//           top: "10%",
//           left: "20%",
//         }}
//       ></div>

//       <div
//         style={{
//           background:
//             "linear-gradient(135deg, rgba(255,255,255,0.9), rgba(255,255,255,0.7))",
//           backdropFilter: "blur(15px)",
//           padding: "40px 20px",
//           borderRadius: "25px",
//           width: "100%",
//           maxWidth: "420px",
//           boxShadow: "0 20px 60px rgba(0,0,0,0.4)",
//           textAlign: "center",
//           border: "1px solid rgba(255,255,255,0.1)",
//         }}
//       >
//         <img
//           src={logo}
//           alt="logo"
//           style={{
//             height: "80px",
//             marginBottom: "15px",
//             objectFit: "contain",
//           }}
//         />

      
//         <h3 style={{ marginBottom: "25px", color: "#3e2a22" }}>
//           Admin Login
//         </h3>

//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             background: "rgba(255,255,255,0.1)",
//             borderRadius: "25px",
//             padding: "12px 15px",
//             marginBottom: "15px",
//           }}
//         >
//           <FaUser style={{ color: "#D4c2BB", marginRight: "10px" }} />
//           <input
//             type="text"
//             placeholder="Mobile"
//             value={mobile}
//             onChange={(e) => setMobile(e.target.value)}
//             style={{
//               border: "none",
//               outline: "none",
//               background: "transparent",
//               width: "100%",
//               color: "#3e2a22",
//             }}
//           />
//         </div>

//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             background: "rgba(255,255,255,0.1)",
//             borderRadius: "25px",
//             padding: "12px 15px",
//             marginBottom: "15px",
//           }}
//         >
//           <FaLock style={{ color: "#D4c2BB", marginRight: "10px" }} />
//           <input
//             type="password"
//             placeholder="Password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             style={{
//               border: "none",
//               outline: "none",
//               background: "transparent",
//               width: "100%",
//               color: "#3e2a22", 
//             }}
//           />
//         </div>

//         <button
//           onClick={handleLogin}
//           style={{
//             width: "100%",
//             border: "none",
//             borderRadius: "25px",
//             padding: "12px",
//             background: "#D4c2BB",
//             color: "#3e2a22",
//             fontWeight: "600",
//             cursor: "pointer",
//             transition: "0.3s",
//           }}
//           onMouseEnter={(e) =>
//             (e.target.style.background = "#c1a99f")
//           }
//           onMouseLeave={(e) =>
//             (e.target.style.background = "#D4c2BB")
//           }
//         >
//           Log In
//         </button>
//       </div>
//     </div>
//   );
// }

// export default Adminlogin;


import React, { useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaUser, FaLock } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import logo from "../../Images/logo2.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Adminlogin() {
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!mobile || !password) {
      toast.error("Please fill all fields");
      return;
    }

    try {
      const res = await axios.post(
        "https://api.d2associates.in/admin-login",
        {
          mobile_no: mobile.trim(),
          password: password.trim(),
        }
      );

      const data = res.data;

      localStorage.setItem("admin", JSON.stringify(data.user));

      if (res.data.user?.role === "admin") {
        toast.success("Login successful");
        navigate("/admin/dashboard");
        window.location.reload();
      }
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Login Failed");
    }
  };

  return (
    <>
      <ToastContainer position="top-center" autoClose={2000} />

      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "linear-gradient(135deg, #6c4636, #a67c6b)",
          position: "relative",
          overflow: "hidden",
          padding: "15px",
        }}
      >
        <style>
          {`
            input:-webkit-autofill {
              -webkit-box-shadow: 0 0 0 1000px transparent inset !important;
              -webkit-text-fill-color: #3e2a22 !important;
            }
          `}
        </style>

        <div
          style={{
            position: "absolute",
            width: "250px",
            height: "250px",
            background: "rgba(212,194,187,0.3)",
            filter: "blur(120px)",
            borderRadius: "50%",
            top: "10%",
            left: "20%",
          }}
        ></div>

        <div
          style={{
            background:
              "linear-gradient(135deg, rgba(255,255,255,0.9), rgba(255,255,255,0.7))",
            backdropFilter: "blur(15px)",
            padding: "40px 20px",
            borderRadius: "25px",
            width: "100%",
            maxWidth: "420px",
            boxShadow: "0 20px 60px rgba(0,0,0,0.4)",
            textAlign: "center",
            border: "1px solid rgba(255,255,255,0.1)",
          }}
        >
          <img
            src={logo}
            alt="logo"
            style={{
              height: "80px",
              marginBottom: "15px",
              objectFit: "contain",
            }}
          />

          <h3 style={{ marginBottom: "25px", color: "#3e2a22" }}>
            Admin Login
          </h3>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              background: "rgba(255,255,255,0.1)",
              borderRadius: "25px",
              padding: "12px 15px",
              marginBottom: "15px",
            }}
          >
            <FaUser style={{ color: "#D4c2BB", marginRight: "10px" }} />
            <input
              type="text"
              placeholder="Mobile"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              style={{
                border: "none",
                outline: "none",
                background: "transparent",
                width: "100%",
                color: "#3e2a22",
              }}
            />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              background: "rgba(255,255,255,0.1)",
              borderRadius: "25px",
              padding: "12px 15px",
              marginBottom: "15px",
            }}
          >
            <FaLock style={{ color: "#D4c2BB", marginRight: "10px" }} />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                border: "none",
                outline: "none",
                background: "transparent",
                width: "100%",
                color: "#3e2a22",
              }}
            />
          </div>

          <button
            onClick={handleLogin}
            style={{
              width: "100%",
              border: "none",
              borderRadius: "25px",
              padding: "12px",
              background: "#D4c2BB",
              color: "#3e2a22",
              fontWeight: "600",
              cursor: "pointer",
              transition: "0.3s",
            }}
            onMouseEnter={(e) =>
              (e.target.style.background = "#c1a99f")
            }
            onMouseLeave={(e) =>
              (e.target.style.background = "#D4c2BB")
            }
          >
            Log In
          </button>
        </div>
      </div>
    </>
  );
}

export default Adminlogin;